define([
  "marionette",
  "underscore",
  "./template/topicResponseCampaignModalTemplate.html",
], function (Marionette, _, TopicResponseCampaignModalTemplate) {
  const TopicResponseCampaignModalView = {};

  TopicResponseCampaignModalView.topicResponseCampaignModalView = Marionette.ItemView.extend({
    template: TopicResponseCampaignModalTemplate,
    events: {
      "change #selectCampaign": function () {
        const campaignId = parseInt(this.$el.find("#selectCampaign option:selected").val(), 10);
        this.trigger("campaign:changed", campaignId);
      },
    },
    triggers: {
      "click #doneButton": "save:campaign",
      "click #cancelButton": "discard:change",
    },
  });

  return TopicResponseCampaignModalView;
});
